import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UsersService } from '../users/users.service';
import { SquadsService } from '../squads/squads.service';
import { LoginService } from '../login/login.service';
import { catchError, lastValueFrom, map, Observable, retry } from 'rxjs';
import { PoSelectOption, PoTableColumn } from '@po-ui/ng-components';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CompetencyProfileService {


  constructor(
    private _http: HttpClient,
    public userService: UsersService,
    public squadsService: SquadsService,
    public loginService: LoginService,
  ) { }

  public selectedTeam = ''
  public teams = [];
  public typeCompetences = [];
  public selectedTypeCompetences = '';
  public jobCareer = [];

  getColumns(): Array<PoTableColumn> {
    return [
      { property: 'id', label: 'ID', visible: false },
      { property: 'typeCompetence.name', label: 'Tipo de Competência' },
    ];
  }

  getColumnsForm(): Array<PoTableColumn> {
    return [
      { property: 'jobCareer', label: 'Cargo' },
      { property: 'levelExpected', label: 'Esperado' },
    ];
  }

  getExpected(): Array<PoSelectOption> {
    return [
      { value: 'notions', label: 'Noções' },
      { value: 'knowledge', label: 'Conhecimento' },
      { value: 'domain', label: 'Domínio' },
      { value: 'expert', label: 'Expert' },
    ];
  }

  get(): Promise<any> {
    return lastValueFrom(this._http
      .get(
        environment.url_api + '/jobcompetency/',
        this.loginService.httpOptions
      ).pipe(
        retry(3),
        map((jobCompetency) => {
          return jobCompetency;
        }),
        catchError(this.loginService.handleError)
      ));
  }

  async getOne(id: number): Promise<any> {
    return await lastValueFrom(this._http
      .get(
        environment.url_api + '/jobcompetency/' + id,
        this.loginService.httpOptions
      ));
  }

  save(params): Observable<any> {
    return this._http
      .post(
        environment.url_api + '/jobcompetency',
        JSON.stringify(params),
        this.loginService.httpOptions
      ).pipe(
        map((res) => {
          return res;
        }),
        catchError(this.loginService.handleError)
      );
  }

  edit(params): Observable<any> {
    return this._http
      .put(
        environment.url_api + '/jobcompetency/' + params.id,
        JSON.stringify(params),
        this.loginService.httpOptions
      ).pipe(
        map((res) => {
          return res;
        }),
        catchError(this.loginService.handleError)
      );
  }

  delete(id): Observable<any> {
    return this._http
      .delete(
        environment.url_api + '/jobcompetency/' + id,
        this.loginService.httpOptions
      ).pipe(
        map((res) => {
          return res;
        }),
        catchError(this.loginService.handleError)
      )
  }

  async getSquadByUser(): Promise<any> {
    try {
      this.teams = await lastValueFrom(this.userService
        .getUserTeam(this.loginService.userToken.id))
      this.teams = this.teams.map(element => ({
        label: element.name,
        value: element.id
      }));
      this.teams.sort((a, b) => {
        return a.label.localeCompare(b.label);
      });

      return this.teams;
    } catch (error) {
      catchError(this.loginService.handleError)
    }
  }

  getJobCompetencyLevel() {
    return lastValueFrom(this._http
      .get(
        environment.url_api + '/jobcompetencylevel/',
        this.loginService.httpOptions
      ).pipe(
        retry(3),
        map((jobCompetency) => {
          return jobCompetency;
        }),
        catchError(this.loginService.handleError)
      ));
  }

  saveJobCompetencyLevel(params): Observable<any> {
    return this._http
      .post(
        environment.url_api + '/jobcompetencylevel/bulk',
        JSON.stringify(params),
        this.loginService.httpOptions
      ).pipe(
        map((res) => {
          return res;
        }),
        catchError(this.loginService.handleError)
      );
  }

  updateJobCompetencyLevel(params): Observable<any> {
    return this._http
    .put(
      environment.url_api + '/jobcompetencylevel/bulk',
      JSON.stringify(params),
      this.loginService.httpOptions
    )
    .pipe(
      map((res) => {
        return res;
      }),
      catchError(this.loginService.handleError)
    );
  }

  deleteJobCompetencyLevel(id): Observable<any> {
    return this._http
      .delete(
        environment.url_api + '/jobcompetencylevel/' + id,
        this.loginService.httpOptions
      ).pipe(
        map((res) => {
          return res;
        }),
        catchError(this.loginService.handleError)
      );
  }

  getJobCareer(): Promise<any> {
    return lastValueFrom(this._http
      .get(
        environment.url_api + '/jobcareer/',
        this.loginService.httpOptions
      ).pipe(
        retry(3),
        map((jobCompetency) => {
          return jobCompetency;
        }),
        catchError(this.loginService.handleError)
      ));
  }

  getJobCareerById(id): Promise<any> {
    return lastValueFrom(this._http
      .get(
        environment.url_api + '/jobcareer/' + id,
        this.loginService.httpOptions
      ).pipe(
        retry(3),
        map((jobCompetency) => {
          return jobCompetency;
        }),
        catchError(this.loginService.handleError)
      ));
  }

  async getTypeCompetences(): Promise<any> {
    return await lastValueFrom(this._http
      .get(
        environment.url_api + '/typecompetences/',
        this.loginService.httpOptions
      ));
  }

  async getTypeCompetencesOptions(): Promise<any> {
    try {
      this.typeCompetences = await this.getTypeCompetences();
      this.typeCompetences = this.typeCompetences.map(element => ({
        label: element.name,
        value: element.id
      }));
      this.typeCompetences.sort((a, b) => {
        return a.label.localeCompare(b.label);
      });
    } catch (error) {
      catchError(this.loginService.handleError)
    }
  }

  async getJobCareerOptions(): Promise<any> {
    try {
      this.jobCareer = await this.getJobCareer();
      this.jobCareer = this.jobCareer.map(element => ({
        label: element.name,
        value: element.id
      }));
      this.jobCareer.sort((a, b) => {
        return a.label.localeCompare(b.label);
      });
    } catch (error) {
      catchError(this.loginService.handleError)
    }
  }

}
